import { render, staticRenderFns } from "./ChartsMonthNumber.vue?vue&type=template&id=8b48ae4e&"
import script from "./ChartsMonthNumber.vue?vue&type=script&lang=js&"
export * from "./ChartsMonthNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports